import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { Settings, Save } from 'lucide-react';

const SiteSettingsPanel = () => {
  const { api } = useAuth();
  const [settings, setSettings] = useState(null);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    api.get('/admin/settings').then(r => setSettings(r.data)).catch(console.error);
  }, []);

  const handleSave = async () => {
    setSaving(true); setMsg('');
    try {
      const { _id, ...data } = settings;
      await api.put('/admin/settings', data);
      setMsg('Settings saved successfully!');
    } catch (err) { setMsg('Error saving settings'); }
    setSaving(false);
  };

  if (!settings) return <div className="admin-section"><p style={{ color: '#555' }}>Loading...</p></div>;

  const update = (key, val) => setSettings({ ...settings, [key]: val });

  return (
    <div className="admin-section">
      <div className="section-header">
        <h2 className="section-title"><Settings size={20} /> Site Settings</h2>
        <button className="btn-primary" onClick={handleSave} disabled={saving}>
          <Save size={16} /> {saving ? 'Saving...' : 'Save Settings'}
        </button>
      </div>
      {msg && <div className="form-msg" style={{ marginBottom: 16 }}>{msg}</div>}

      <div className="two-col">
        <div className="admin-card">
          <h3 className="card-subtitle">General</h3>
          <label className="form-label">Site Title</label>
          <input className="form-input" value={settings.site_title || ''} onChange={e => update('site_title', e.target.value)} />
          <label className="form-label">Site Subtitle</label>
          <input className="form-input" value={settings.site_subtitle || ''} onChange={e => update('site_subtitle', e.target.value)} />
          <label className="form-label">Footer Text</label>
          <input className="form-input" value={settings.footer_text || ''} onChange={e => update('footer_text', e.target.value)} />
        </div>

        <div className="admin-card">
          <h3 className="card-subtitle">SEO (Global)</h3>
          <label className="form-label">Meta Title</label>
          <input className="form-input" value={settings.meta_title || ''} onChange={e => update('meta_title', e.target.value)} />
          <label className="form-label">Meta Description</label>
          <textarea className="form-textarea" value={settings.meta_description || ''} onChange={e => update('meta_description', e.target.value)} rows={3} />
          <label className="form-label">Meta Keywords</label>
          <input className="form-input" value={settings.meta_keywords || ''} onChange={e => update('meta_keywords', e.target.value)} />
          <label className="form-label">OG Image URL</label>
          <input className="form-input" value={settings.og_image || ''} onChange={e => update('og_image', e.target.value)} />
        </div>
      </div>

      <div className="two-col" style={{ marginTop: 16 }}>
        <div className="admin-card">
          <h3 className="card-subtitle">Join Group Links</h3>
          <label className="form-label">WhatsApp Group</label>
          <input className="form-input" value={settings.social_whatsapp || ''} onChange={e => update('social_whatsapp', e.target.value)} placeholder="https://chat.whatsapp.com/xxx" />
          <label className="form-label">Telegram Group</label>
          <input className="form-input" value={settings.social_telegram || ''} onChange={e => update('social_telegram', e.target.value)} placeholder="https://t.me/+xxx" />
        </div>

        <div className="admin-card">
          <h3 className="card-subtitle">Advanced Code</h3>
          <label className="form-label">Google Analytics ID</label>
          <input className="form-input" value={settings.google_analytics || ''} onChange={e => update('google_analytics', e.target.value)} placeholder="G-XXXXXXXXXX" />
          <label className="form-label">Custom Head Code</label>
          <textarea className="form-textarea" value={settings.custom_head_code || ''} onChange={e => update('custom_head_code', e.target.value)} rows={3}
            placeholder="<script>...</script>" style={{ fontFamily: 'monospace', fontSize: 12 }} />
          <label className="form-label">robots.txt</label>
          <textarea className="form-textarea" value={settings.robots_txt || ''} onChange={e => update('robots_txt', e.target.value)} rows={3}
            style={{ fontFamily: 'monospace', fontSize: 12 }} />
        </div>
      </div>
    </div>
  );
};

export default SiteSettingsPanel;
